export enum DiaperUsageEnum {
  DAY = 'Day',
  NIGHT = 'Night',
}

// Translation keys for diaper usage types
export const DiaperUsageTranslationKeys: Record<DiaperUsageEnum, string> = {
  [DiaperUsageEnum.DAY]: 'day',
  [DiaperUsageEnum.NIGHT]: 'night',
};

// Helper function to get translation key for diaper usage
export const getDiaperUsageTranslationKey = (usageType: string): string => {
  const usage = Object.values(DiaperUsageEnum).find(
    (type) => type === usageType
  );
  
  if (usage) {
    return DiaperUsageTranslationKeys[usage as DiaperUsageEnum];
  }
  
  return 'unknown';
}; 